module.exports = __webpack_public_path__ + "img/43d798f.jpg";